import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Navbar from '../navigation/Navbar'
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import HeroMaster from '../hero/HeroMaster';
import { useMode } from "../../../utils/useMode";
import { useSongs } from '../../hooks/useSongs';

import PlaylistMaster from '../playlists/PlaylistMaster';
import PopularSongMaster from '../popularSongs/PopularSongMaster';
import ArtistMaster from '../artists/ArtistsMaster';
import SongsMaster from '../songs/SongsMaster';

const Home = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "home";
    const [, setActiveTab] = useState(initialTab);
    const mode = useMode();

    const {
        data: songs = [],
    } = useSongs();


    const handleTabClick = (tab) => {
        const sectionId = tab;
        setActiveTab(tab);
        scroller.scrollTo(sectionId, {
            duration: 500,
            smooth: true,
            offset: -80,
        });
    };


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const initialTab = queryParams.get("activeTab") || "home";
        setActiveTab(initialTab);
        scroller.scrollTo(initialTab, {
            duration: 500,
            smooth: true,
            offset: -80,
        });
    }, [location.search]);


    return (
        <Box sx={{ bgcolor: "background.default" }}>
            <Navbar handleTabClick={handleTabClick} />
            <HeroMaster mode={mode} songsLength={songs ? songs.length : null} />
            <PlaylistMaster />
            <PopularSongMaster />
            <ArtistMaster />
            <SongsMaster />
        </Box>
    )
}

export default Home